<template>
  <div class="login">
    <div class="box">
      <i class="el-icon-loading"></i>
    </div>
  </div>
</template>
<script>
// import Identify from '@/components/Identify'
// import md5 from 'js-md5' // md5加密

export default {
  name: 'login',
  components: {
    // Identify
  },
  data() {
    return {
      params: {},
      loading: false
    }
  },
  methods: {
    // 解析页面URL
    getUrlParam(url) {
      var paramStr = url.substring(url.indexOf('?') + 1, url.length).split('&')
      var j
      var paramObj = {}
      for (var i = 0; (j = paramStr[i]); i++) {
        console.log(i)
        paramObj[j.substring(0, j.indexOf('='))] = j.substring(j.indexOf('=') + 1, j.length)
      }
      var returnValue = paramObj
      if (typeof returnValue === 'undefined') {
        return ''
      } else {
        return returnValue
      }
    },
    // 登录
    doLogin() {
      const params = {
        code: this.params.code
      }
      this.loading = true
      this.$get('/login/transferWechatLogin', params)
        .then(response => {
          this.loading = false
          if (response.status === 200) {
            this.$common.session.set('userInfo', response.data)
            this.$common.session.set('token', response.data.token)
            this.$router.push({
              name: 'FlowPublic'
            })
          } else {
            // 前往注册
            window.location.href = 'http://17l.link/dist/?id=1&targetName=LoginBindFlow&wechatLogin=true&state=123'
            this.$root.$children[0].vueAlert({ message: response.status + ':' + response.msg, type: 'error' })
          }
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          this.$root.$children[0].vueAlert({ message: '请求失败，请联系管理员！', type: 'error' })
        })
    }
  },
  mounted() {
    this.params = this.getUrlParam(window.location.href)
    this.doLogin() // 登录
    this.$common.storage.clear()
  },
  created() {},
  beforeDestroy() {}
}
</script>

<style lang="less"></style>
<style lang="less" scoped>
.login {
  .box {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      font-size: 10vw;
    }
  }
}
</style>
